import types from './types';

const getInitialData = (isCreationMode, isCloneMode) => ({
  type: types.GET_CHEMICAL_PRODUCT_INITIAL_DATA,
  params: { isCreationMode, isCloneMode }
});

const getChemicalProduct = (id, isCloneMode) => ({
  type: types.GET_CHEMICAL_PRODUCT,
  params: { id, isCloneMode }
});

const getChemicalProductSdsFiles = (id, isCloneMode) => ({
  type: types.GET_CHEMICAL_PRODUCT_SDS_FILES,
  params: { id, isCloneMode }
});

const getChemicalProductTitleDetails = id => ({
  type: types.GET_CHEMICAL_PRODUCT_TITLE_DETAILS,
  params: { id }
});

const deleteChemicalProduct = (id, redirect) => ({
  type: types.DELETE_CHEMICAL_PRODUCT,
  params: { id, redirect }
});

const getNewChemicalProduct = id => ({
  type: types.GET_NEW_CHEMICAL_PRODUCT,
  params: { id }
});
const getNewChemicalProductFromCurrent = chemicalProduct => ({
  type: types.GET_NEW_CHEMICAL_PRODUCT_FROM_CURRENT,
  params: { chemicalProduct }
});

const saveChemicalProduct = saveDto => ({
  type: types.SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL,
  params: { saveDto }
});

const stateChange = () => ({ type: types.STATE_CHANGE });

export const cmrClassCalculation = () => ({ type: types.CMR_CLASS_CALCULATION });

export const hazardsCalculation = () => ({ type: types.HAZARDS_CALCULATION });

export default {
  getInitialData,
  getChemicalProduct,
  getChemicalProductSdsFiles,
  getChemicalProductTitleDetails,
  getNewChemicalProduct,
  getNewChemicalProductFromCurrent,
  saveChemicalProduct,
  deleteChemicalProduct,
  stateChange,
  cmrClassCalculation,
  hazardsCalculation
};
